import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage } from '@fortawesome/free-solid-svg-icons';
import '../../styles/components/media/ImagePlaceholder.css';

const ImagePlaceholder = ({
  width = '100%',
  height = '200px',
  className = '',
  showIcon = true,
  text = 'Image placeholder'
}) => {
  return (
    <div
      className={`image-placeholder ${className}`}
      style={{ width, height }}
    >
      {showIcon && (
        <div className="image-placeholder__icon">
          <FontAwesomeIcon 
            icon={faImage} 
            className="image-placeholder__fa-icon"
          />
        </div>
      )}
      {text && (
        <div className="image-placeholder__text">
          {text}
        </div>
      )}
    </div>
  );
};

export default ImagePlaceholder;
